import React, { useContext, useCallback } from 'react';
import { Button } from '@fluentui/react-components';
import PropTypes from 'prop-types';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';
import { useOverviewPageStyles } from '../style/overview-page-phase-2-style';
import tooManyAccountsError from '../media/tooManyAccountsError.png';

export const TooMuchAccountsError = ({ i18n }) => {
  const { scope } = useContext(ScopeContext);
  const styles = useOverviewPageStyles();

  const onClick = useCallback(() => {
    scope.save(getRoutePathById(allSiteMap, 'overview'));
  }, [scope]);

  return (
    <div className={styles.errorContainer}>
      <img src={tooManyAccountsError} alt="Too many accounts" className={styles.errorImage} />
      <p className={styles.errorMessage}>
        {i18n.getString(_TL_('The tiles cannot be loaded because there are too many accounts. Please view the accounts on the management tab.'))}
      </p>
      <Button appearance="primary" onClick={onClick}>
        {i18n.getString(_TL_('Go to management tab'))}
      </Button>
    </div>
  );
};

TooMuchAccountsError.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
